import { Modal, notification, Text } from "components/common";
import { useTranslation } from "react-i18next";
import { useAddToWatchlistMutation,useRemoveFromWatchlistMutation } from "features/leads/api";

export default function WatchListForm({ lead, formRef }) {
  const { t } = useTranslation();
  const [addToWatchlist,{isLoading:isAdding}] = useAddToWatchlistMutation();
  const [removeFromWatchlist,{isLoading:isRemoving}] = useRemoveFromWatchlistMutation();
  const isInWatchlist = lead?.isAddedToWatchList;
  const handleSubmit = async () => {
    try {
      let response;
      if (isInWatchlist) {
        response = await removeFromWatchlist(lead?.id).unwrap();
        notification.success({ message: t("Removed from Watchlist") });
      } else {
        response = await addToWatchlist(lead?.id).unwrap();
        notification.success({ message: t("Added to Watchlist") });
      }
      formRef.current?.setVisible(false);
    } catch (error) {
      notification.error({ message: error?.message });
    }
  };
  return (
    <Modal
      ref={formRef}
      okText={isInWatchlist ? t("Remove") : t("Add")}
      cancelText={t("Cancel")}
      title={isInWatchlist ? t("Remove from Watchlist") : t("Add to Watchlist")}
      width={500}
      destroyOnClose
      onCancel={() => formRef.current?.setVisible(false)}
      onOk={handleSubmit}
      loading={isAdding || isRemoving}
    >
      <Text>
        {isInWatchlist
          ? t("Are you sure you want to remove this lead from the watchlist?")
          : t("Are you sure you want to add this lead to the watchlist?")}
      </Text>
    </Modal>
  );
}
